import { useState } from 'react';
import { addUserReferral } from '../../API/ProtectedAuth';
import { validateReferralForm, getInstantPhoneError } from '../../Utils/validateForm';
import { handleApiError } from '../../Utils/errorHandler';

export default function useAddReferral(userId, options = {}) {
  const { onSuccess } = options;
  const [values, setValues] = useState({
    referrer_phone: ''
  });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));

    if (name === 'referrer_phone') {
      const phoneError = getInstantPhoneError(value);
      if (phoneError) {
        setErrors((prev) => ({ ...prev, referrer_phone: phoneError }));
      } else {
        setErrors((prev) => {
          const { referrer_phone, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const validationErrors = validateReferralForm(values);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsLoading(true);
    try {
      await addUserReferral(userId, {
        referrer_phone: values.referrer_phone
      });
      setSuccess('تمت إضافة الإحالة بنجاح');
      setValues({ referrer_phone: '' });
      if (typeof onSuccess === 'function') {
        try { setTimeout(() => onSuccess(), 1200); } catch {}
      }
    } catch (err) {
      // توحيد رسالة خطأ الباك ايند كما في Login
      const data = err?.response?.data;
      if (data) {
        let msg = 'فشل إضافة الإحالة. تحقق من البيانات أو الشبكة.';
        if (typeof data === 'string') {
          msg = data;
        } else if (typeof data === 'object') {
          try {
            msg = Object.values(data).flat().join('، ');
          } catch {
            msg = handleApiError(err);
          }
        }
        setError(msg);
      } else {
        setError(handleApiError(err));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    values,
    errors,
    error,
    success,
    isLoading,
    handleChange,
    handleSubmit,
    setError,
    setSuccess
  };
}


